import bootstrap from '../bootstrapper';
import Participant from './participant-application';

bootstrap(Participant, '/take');

if (module.hot) {
  module.hot.accept();
}
